import _ from 'underscore';
import Radio from 'backbone.radio';
import incidents from '@/collections/incidents';
import components from '@/collections/components';
import scheduled_maintenance from '@/collections/scheduled_maintenance';

    var globalCh = Radio.channel('global');

    var STATUS_FETCH_INTERVAL = 60 * 1000;
    // Make incidents, components and scheduled maintanance
    // available as app globals
    globalCh.reply('incidents', function() { return incidents; });
    globalCh.reply('components', function() { return components; });
    globalCh.reply('scheduled_maintenance', function() { return scheduled_maintenance; });

    export default function(options) {
        if (options.features && options.features.serverStatus != true) {
            return;
        }
        // Incidents
        incidents.fetch();
        incidents.fetchTimer = setInterval(_.bind(incidents.fetch, incidents), STATUS_FETCH_INTERVAL);

        // Components
        components.fetch();
        components.fetchTimer = setInterval(_.bind(components.fetch, components), STATUS_FETCH_INTERVAL);

        // Scheduled maintenance
        scheduled_maintenance.fetch();
        scheduled_maintenance.fetchTimer = setInterval(_.bind(scheduled_maintenance.fetch, scheduled_maintenance), STATUS_FETCH_INTERVAL);
    }

